import { render, staticRenderFns } from "./WorkHome.vue?vue&type=template&id=10af7c58&scoped=true&"
import script from "./WorkHome.vue?vue&type=script&lang=js&"
export * from "./WorkHome.vue?vue&type=script&lang=js&"
import style0 from "./WorkHome.vue?vue&type=style&index=0&id=10af7c58&prod&lang=scss&scoped=true&"
import style1 from "./WorkHome.vue?vue&type=style&index=1&id=10af7c58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af7c58",
  null
  
)

export default component.exports